import { defineComponent, h } from "vue";
import { HugeiconsIcon } from "@hugeicons/vue";
import {
	Add01Icon as _Add01Icon,
	AlertCircleIcon as _AlertCircleIcon,
	ArrowLeft01Icon as _ArrowLeft01Icon,
	ArrowRight01Icon as _ArrowRight01Icon,
	Building01Icon as _Building01Icon,
	Cancel01Icon as _Cancel01Icon,
	ChartLineData01Icon as _ChartLineData01Icon,
	CheckmarkCircleIcon as _CheckmarkCircleIcon,
	Clock01Icon as _Clock01Icon,
	CreditCardIcon as _CreditCardIcon,
	Crown02Icon as _Crown02Icon,
	Delete01Icon as _Delete01Icon,
	Edit01Icon as _Edit01Icon,
	FilterIcon as _FilterIcon,
	FolderOpenIcon as _FolderOpenIcon,
	GlobeIcon as _GlobeIcon,
	Home03Icon as _Home03Icon,
	Layers01Icon as _Layers01Icon,
	Logout01Icon as _Logout01Icon,
	Menu01Icon as _Menu01Icon,
	Moon01Icon as _Moon01Icon,
	MoreVerticalIcon as _MoreVerticalIcon,
	NotificationIcon as _NotificationIcon,
	PaintBrushIcon as _PaintBrushIcon,
	PrinterIcon as _PrinterIcon,
	Rocket01Icon as _Rocket01Icon,
	Search01Icon as _Search01Icon,
	Settings01Icon as _Settings01Icon,
	SettingsIcon as _SettingsIcon,
	Sun01Icon as _Sun01Icon,
	UserIcon as _UserIcon,
	CloudUploadIcon as _CloudUploadIcon,
	HardDriveIcon as _HardDriveIcon,
	Image02Icon as _Image02Icon,
	Tag01Icon as _Tag01Icon,
	WrenchIcon as _WrenchIcon,
	SentIcon as _SentIcon,
	AiChat02Icon as _AiChat02Icon,
	Copy01Icon as _Copy01Icon,
	SquareLock02Icon as _SquareLock02Icon,
	ComputerIcon as _ComputerIcon,
	UserGroupIcon as _UserGroupIcon,
	Camera01Icon as _Camera01Icon,
	Calendar03Icon as _Calendar03Icon,
	DragDropIcon as _DragDropIcon,
	InspectCodeIcon as _InspectCodeIcon,
	DashboardSquare01Icon as _DashboardSquare01Icon,
	Folder01Icon as _Folder01Icon,
	CloudIcon as _CloudIcon,
	CubeIcon as _CubeIcon,
	PaintBrush01Icon as _PaintBrush01Icon,
	SidebarLeftIcon as _SidebarLeftIcon,
	ArrowDown01Icon as _ArrowDown01Icon,
	MoreHorizontalIcon as _MoreHorizontalIcon,
	LinkSquare01Icon as _LinkSquare01Icon,
	UserCircleIcon as _UserCircleIcon,
	DiscordIcon as _DiscordIcon,
	RedditIcon as _RedditIcon,
	Moon02Icon as _Moon02Icon,
	Sun03Icon as _Sun03Icon,
	Loading03Icon as _Loading03Icon,
	CheckmarkCircle02Icon as _CheckmarkCircle02Icon,
	Alert02Icon as _Alert02Icon,
	InformationCircleIcon as _InformationCircleIcon,
	Tick02Icon as _Tick02Icon,
	PlusSignIcon as _PlusSignIcon,
	Delete02Icon as _Delete02Icon,
	PencilEdit02Icon as _PencilEdit02Icon,
	Download01Icon as _Download01Icon,
	Upload01Icon as _Upload01Icon,
	RefreshIcon as _RefreshIcon,
	ViewIcon as _ViewIcon,
	Timer01Icon as _Timer01Icon,
	WeightScale01Icon as _WeightScale01Icon,
	StarIcon as _StarIcon,
	Share01Icon as _Share01Icon,
	Link01Icon as _Link01Icon,
	File01Icon as _File01Icon,
	Image01Icon as _Image01Icon,
	SortingAZ01Icon as _SortingAZ01Icon,
	PaintBrush04Icon as _PaintBrush04Icon,
	EraserIcon as _EraserIcon,
	SquareIcon as _SquareIcon,
	PentagonIcon as _PentagonIcon,
	Hold01Icon as _Hold01Icon,
	ZoomInAreaIcon as _ZoomInAreaIcon,
	ZoomOutAreaIcon as _ZoomOutAreaIcon,
	CenterFocusIcon as _CenterFocusIcon,
	AiMagicIcon as _AiMagicIcon,
	ImageAdd02Icon as _ImageAdd02Icon,
	ClipboardIcon as _ClipboardIcon,
	GitMergeIcon as _GitMergeIcon,
	ArrowUp01Icon as _ArrowUp01Icon,
	Undo02Icon as _Undo02Icon,
	Redo02Icon as _Redo02Icon,
	ViewOffSlashIcon as _ViewOffSlashIcon,
	DropperIcon as _DropperIcon,
	SquareUnlock02Icon as _SquareUnlock02Icon,
	FloppyDiskIcon as _FloppyDiskIcon,
	BookOpen01Icon as _BookOpen01Icon,
	BubbleChatIcon as _BubbleChatIcon,
	Share08Icon as _Share08Icon,
	SecurityCheckIcon as _SecurityCheckIcon,
	Store01Icon as _Store01Icon,
	ArrowReloadHorizontalIcon as _ArrowReloadHorizontalIcon,
	DatabaseRestoreIcon as _DatabaseRestoreIcon,
	HourglassIcon as _HourglassIcon,
	SlidersHorizontalIcon as _SlidersHorizontalIcon,
	LaptopIcon as _LaptopIcon,
	Archive02Icon as _Archive02Icon,
	Notification03Icon as _Notification03Icon,
	CloudSavingDone01Icon as _CloudSavingDone01Icon,
	Analytics01Icon as _Analytics01Icon,
	UserMultipleIcon as _UserMultipleIcon,
	Invoice01Icon as _Invoice01Icon,
	Money03Icon as _Money03Icon,
} from "@hugeicons-pro/core-stroke-rounded";

// Icons follow the design system: Hugeicons stroke rounded at a 1.7 stroke,
// 16px by default, colored by currentColor and hidden from screen readers
// (the control's text or aria-label carries the meaning).
function createIcon(name: string, iconData: any) {
	return defineComponent({
		name,
		inheritAttrs: false,
		props: {
			size: { type: [Number, String], default: 16 },
			strokeWidth: { type: Number, default: 1.7 },
		},
		setup(props, { attrs }) {
			return () =>
				h(HugeiconsIcon, {
					icon: iconData,
					size: props.size,
					strokeWidth: props.strokeWidth,
					"aria-hidden": "true",
					...attrs,
				});
		},
	});
}

export const Add01Icon = createIcon("Add01Icon", _Add01Icon);
export const AlertCircleIcon = createIcon("AlertCircleIcon", _AlertCircleIcon);
export const ArrowLeft01Icon = createIcon("ArrowLeft01Icon", _ArrowLeft01Icon);
export const ArrowRight01Icon = createIcon("ArrowRight01Icon", _ArrowRight01Icon);
export const Building01Icon = createIcon("Building01Icon", _Building01Icon);
export const Cancel01Icon = createIcon("Cancel01Icon", _Cancel01Icon);
export const ChartLineData01Icon = createIcon("ChartLineData01Icon", _ChartLineData01Icon);
export const CheckmarkCircleIcon = createIcon("CheckmarkCircleIcon", _CheckmarkCircleIcon);
export const CloudUploadIcon = createIcon("CloudUploadIcon", _CloudUploadIcon);
export const Clock01Icon = createIcon("Clock01Icon", _Clock01Icon);
export const CreditCardIcon = createIcon("CreditCardIcon", _CreditCardIcon);
export const Crown02Icon = createIcon("Crown02Icon", _Crown02Icon);
export const Delete01Icon = createIcon("Delete01Icon", _Delete01Icon);
export const Edit01Icon = createIcon("Edit01Icon", _Edit01Icon);
export const FilterIcon = createIcon("FilterIcon", _FilterIcon);
export const FolderOpenIcon = createIcon("FolderOpenIcon", _FolderOpenIcon);
export const GlobeIcon = createIcon("GlobeIcon", _GlobeIcon);
export const HardDriveIcon = createIcon("HardDriveIcon", _HardDriveIcon);
export const Home03Icon = createIcon("Home03Icon", _Home03Icon);
export const Image02Icon = createIcon("Image02Icon", _Image02Icon);
export const Layers01Icon = createIcon("Layers01Icon", _Layers01Icon);
export const Logout01Icon = createIcon("Logout01Icon", _Logout01Icon);
export const Menu01Icon = createIcon("Menu01Icon", _Menu01Icon);
export const Moon01Icon = createIcon("Moon01Icon", _Moon01Icon);
export const MoreVerticalIcon = createIcon("MoreVerticalIcon", _MoreVerticalIcon);
export const NotificationIcon = createIcon("NotificationIcon", _NotificationIcon);
export const PaintBrushIcon = createIcon("PaintBrushIcon", _PaintBrushIcon);
export const PrinterIcon = createIcon("PrinterIcon", _PrinterIcon);
export const Rocket01Icon = createIcon("Rocket01Icon", _Rocket01Icon);
export const Search01Icon = createIcon("Search01Icon", _Search01Icon);
export const Settings01Icon = createIcon("Settings01Icon", _Settings01Icon);
export const SettingsIcon = createIcon("SettingsIcon", _SettingsIcon);
export const Sun01Icon = createIcon("Sun01Icon", _Sun01Icon);
export const Tag01Icon = createIcon("Tag01Icon", _Tag01Icon);
export const UserIcon = createIcon("UserIcon", _UserIcon);
export const WrenchIcon = createIcon("WrenchIcon", _WrenchIcon);
export const SentIcon = createIcon("SentIcon", _SentIcon);
export const AiChat02Icon = createIcon("AiChat02Icon", _AiChat02Icon);
export const Copy01Icon = createIcon("Copy01Icon", _Copy01Icon);
export const SquareLock02Icon = createIcon("SquareLock02Icon", _SquareLock02Icon);
export const ComputerIcon = createIcon("ComputerIcon", _ComputerIcon);
export const UserGroupIcon = createIcon("UserGroupIcon", _UserGroupIcon);
export const Camera01Icon = createIcon("Camera01Icon", _Camera01Icon);
export const Calendar03Icon = createIcon("Calendar03Icon", _Calendar03Icon);
export const DragDropIcon = createIcon("DragDropIcon", _DragDropIcon);
export const InspectCodeIcon = createIcon("InspectCodeIcon", _InspectCodeIcon);
export const DashboardSquare01Icon = createIcon("DashboardSquare01Icon", _DashboardSquare01Icon);
export const Folder01Icon = createIcon("Folder01Icon", _Folder01Icon);
export const CloudIcon = createIcon("CloudIcon", _CloudIcon);
export const CubeIcon = createIcon("CubeIcon", _CubeIcon);
export const PaintBrush01Icon = createIcon("PaintBrush01Icon", _PaintBrush01Icon);
export const SidebarLeftIcon = createIcon("SidebarLeftIcon", _SidebarLeftIcon);
export const ArrowDown01Icon = createIcon("ArrowDown01Icon", _ArrowDown01Icon);
export const MoreHorizontalIcon = createIcon("MoreHorizontalIcon", _MoreHorizontalIcon);
export const LinkSquare01Icon = createIcon("LinkSquare01Icon", _LinkSquare01Icon);
export const UserCircleIcon = createIcon("UserCircleIcon", _UserCircleIcon);
export const DiscordIcon = createIcon("DiscordIcon", _DiscordIcon);
export const RedditIcon = createIcon("RedditIcon", _RedditIcon);
export const Moon02Icon = createIcon("Moon02Icon", _Moon02Icon);
export const Sun03Icon = createIcon("Sun03Icon", _Sun03Icon);
export const Loading03Icon = createIcon("Loading03Icon", _Loading03Icon);
export const CheckmarkCircle02Icon = createIcon("CheckmarkCircle02Icon", _CheckmarkCircle02Icon);
export const Alert02Icon = createIcon("Alert02Icon", _Alert02Icon);
export const InformationCircleIcon = createIcon("InformationCircleIcon", _InformationCircleIcon);
export const Tick02Icon = createIcon("Tick02Icon", _Tick02Icon);
export const PlusSignIcon = createIcon("PlusSignIcon", _PlusSignIcon);
export const Delete02Icon = createIcon("Delete02Icon", _Delete02Icon);
export const PencilEdit02Icon = createIcon("PencilEdit02Icon", _PencilEdit02Icon);
export const Download01Icon = createIcon("Download01Icon", _Download01Icon);
export const Upload01Icon = createIcon("Upload01Icon", _Upload01Icon);
export const RefreshIcon = createIcon("RefreshIcon", _RefreshIcon);
export const ViewIcon = createIcon("ViewIcon", _ViewIcon);
export const Timer01Icon = createIcon("Timer01Icon", _Timer01Icon);
export const WeightScale01Icon = createIcon("WeightScale01Icon", _WeightScale01Icon);
export const StarIcon = createIcon("StarIcon", _StarIcon);
export const Share01Icon = createIcon("Share01Icon", _Share01Icon);
export const Link01Icon = createIcon("Link01Icon", _Link01Icon);
export const File01Icon = createIcon("File01Icon", _File01Icon);
export const Image01Icon = createIcon("Image01Icon", _Image01Icon);
export const SortingAZ01Icon = createIcon("SortingAZ01Icon", _SortingAZ01Icon);

// Color extraction (src/components/admin/colorExtraction).
export const PaintBrush04Icon = createIcon("PaintBrush04Icon", _PaintBrush04Icon);
export const EraserIcon = createIcon("EraserIcon", _EraserIcon);
export const SquareIcon = createIcon("SquareIcon", _SquareIcon);
export const PentagonIcon = createIcon("PentagonIcon", _PentagonIcon);
export const Hold01Icon = createIcon("Hold01Icon", _Hold01Icon);
export const ZoomInAreaIcon = createIcon("ZoomInAreaIcon", _ZoomInAreaIcon);
export const ZoomOutAreaIcon = createIcon("ZoomOutAreaIcon", _ZoomOutAreaIcon);
export const CenterFocusIcon = createIcon("CenterFocusIcon", _CenterFocusIcon);
export const AiMagicIcon = createIcon("AiMagicIcon", _AiMagicIcon);
export const ImageAdd02Icon = createIcon("ImageAdd02Icon", _ImageAdd02Icon);
export const ClipboardIcon = createIcon("ClipboardIcon", _ClipboardIcon);
export const GitMergeIcon = createIcon("GitMergeIcon", _GitMergeIcon);
export const ArrowUp01Icon = createIcon("ArrowUp01Icon", _ArrowUp01Icon);
export const Undo02Icon = createIcon("Undo02Icon", _Undo02Icon);
export const Redo02Icon = createIcon("Redo02Icon", _Redo02Icon);
export const ViewOffSlashIcon = createIcon("ViewOffSlashIcon", _ViewOffSlashIcon);
export const DropperIcon = createIcon("DropperIcon", _DropperIcon);
export const SquareUnlock02Icon = createIcon("SquareUnlock02Icon", _SquareUnlock02Icon);
export const FloppyDiskIcon = createIcon("FloppyDiskIcon", _FloppyDiskIcon);
export const BookOpen01Icon = createIcon("BookOpen01Icon", _BookOpen01Icon);
export const BubbleChatIcon = createIcon("BubbleChatIcon", _BubbleChatIcon);
export const Share08Icon = createIcon("Share08Icon", _Share08Icon);
export const SecurityCheckIcon = createIcon("SecurityCheckIcon", _SecurityCheckIcon);
export const Store01Icon = createIcon("Store01Icon", _Store01Icon);
export const ArrowReloadHorizontalIcon = createIcon("ArrowReloadHorizontalIcon", _ArrowReloadHorizontalIcon);
export const DatabaseRestoreIcon = createIcon("DatabaseRestoreIcon", _DatabaseRestoreIcon);
export const HourglassIcon = createIcon("HourglassIcon", _HourglassIcon);
export const SlidersHorizontalIcon = createIcon("SlidersHorizontalIcon", _SlidersHorizontalIcon);
export const LaptopIcon = createIcon("LaptopIcon", _LaptopIcon);
export const Archive02Icon = createIcon("Archive02Icon", _Archive02Icon);
export const Notification03Icon = createIcon("Notification03Icon", _Notification03Icon);
export const CloudSavingDone01Icon = createIcon("CloudSavingDone01Icon", _CloudSavingDone01Icon);
export const Analytics01Icon = createIcon("Analytics01Icon", _Analytics01Icon);
export const UserMultipleIcon = createIcon("UserMultipleIcon", _UserMultipleIcon);
export const Invoice01Icon = createIcon("Invoice01Icon", _Invoice01Icon);
export const Money03Icon = createIcon("Money03Icon", _Money03Icon);
